module.exports = __webpack_public_path__ + "static/media/sitiouno_sc.f618706c.jpg";